export default __webpack_public_path__ + "static/media/avista_icon.49fdd863.svg";